import React from "react";
import "./CityModal.css";

interface Props {
  show: boolean;
  onClose: () => void;
  onConfirm: (city: string) => void;
}

const CityModal: React.FC<Props> = ({ show, onClose, onConfirm }) => {
  const [city, setCity] = React.useState("");

  const cities = ["Indore"];

  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <div className="modal-header">
          <h3>Select Your City</h3>
          {/* <span className="modal-close" onClick={onClose}>
            &times;
          </span> */}
        </div>

        <select
          value={city}
          onChange={(e) => setCity(e.target.value)}
          className="modal-input"
        >
          <option value="">-- Select City --</option>
          {cities.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>

        <div className="modal-footer">
          {/* <button className="btn cancel" onClick={onClose}>
            Cancel
          </button> */}
          <button
            className="btn confirm"
            onClick={() => {
              if (city) {
                onConfirm(city);
                onClose();
              }
            }}
            disabled={!city}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default CityModal;
